import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** Neutral chip. */
export function Chip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded border border-input bg-surface-2 px-2 py-1 text-xs text-muted-foreground',
        className,
      )}
    >
      {children}
    </span>
  )
}

/**
 * Risk pill — a coloured dot + translucent fill in the same risk tone. State is
 * carried by form + colour, never colour alone. `tone` is a CSS colour, e.g.
 * tok('--flare') or riskColor(51).
 */
export function RiskChip({ label, tone }: { label: ReactNode; tone: string }) {
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded px-2 py-1 text-xs font-semibold"
      style={{ color: tone, background: `color-mix(in srgb, ${tone} 14%, transparent)` }}
    >
      <span className="size-2 shrink-0 rounded-[3px]" style={{ background: tone }} />
      {label}
    </span>
  )
}
